import { render, staticRenderFns } from "./ClientDashboardBase.vue?vue&type=template&id=0d5e8a08&scoped=true&"
import script from "./ClientDashboardBase.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardBase.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboardBase.vue?vue&type=style&index=0&id=0d5e8a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e8a08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSkeletonLoader,VTooltip})
